
export default {
    methods: {
        callCashout() {
            clearTimeout(this.cashoutTimeOut);
            for (let key in this.cashoutMarketData) {
                let currCashout = this.cashoutMarketData[key];
                let currMarket;
                if (currCashout.type == 'market') {
                    currMarket = this.matchOddsData.find(item => item.mid == key);
                    if (!currMarket) continue;
                } else {
                    currMarket = this.bookmakerData.ml.find(item => item.mi == key);
                    if (!currMarket) continue;
                }
                let {value, betData} = this.getCashoutValue(currMarket, currCashout.type);
                currCashout.value = value;
                currCashout.bet = betData?.[0];
            }
            this.cashoutTimeOut = setTimeout(() => {
                this.callCashout();
            }, 2000);
        },
        calculateCashoutStake(book) {
            try {
                if (book) {
                    let stats = [];
                    for (let i = 0; i < book.length; i++) {
                        const e = book[i];
                        const bet_type = e.pl < 0 ? 1 : -1; // 1 is lay -1 is back
                        const rev_bet_odds = bet_type == -1 ? (e.back_odds - 1) : (e.lay_odds - 1);
                        const bet_odds = bet_type == 1 ? (e.back_odds - 1) : (e.lay_odds - 1);
                        const real_bet_odds = bet_type == 1 ? (e.back_odds) : (e.lay_odds);
                        const rev_bet = (e.pl * -bet_type) / rev_bet_odds;
                        stats.push({ ...e, bet_type, bet_odds, rev_bet_odds, rev_bet, real_bet_odds });
                    };
                    stats = stats.sort((a, b) => Math.abs(a.rev_bet) - Math.abs(b.rev_bet));
                    const [bet1, stake1] = this.findBetFromBook(stats[1].bet_type, stats[1].bet_odds, stats[1].pl, stats[0].pl);
                    stats[1].bet = Math.abs(bet1);
                    if (stats[2]) {
                        const newStake = stats[2].pl - (stats[1].bet * stats[1].bet_type)
                        const [bet2, stake2] = this.findBetFromBook(stats[2].bet_type, stats[2].bet_odds, newStake, stake1);
                        stats[2].bet = Math.abs(bet2);
                        stats = stats.map(e => ({ ...e, finalStake: stake2 }));
                        if (bet1 != 0) {
                            return [stats[1], stats[2]];
                        } else {
                            return [stats[2]];
                        }
                    }
                    stats = stats.map(e => ({ ...e, finalStake: stake1 }));
                    return [stats[1]];
                }
            } catch (e) {
                console.log('=====', e)
            }
        },
        // Book 1 will be the one on which the bet would be done. Book 2 is for matching the ref
        findBetFromBook(bet_type, odds, stake1, stake2) {
            switch (bet_type) {
                case 1: //Lay
                    let [betRev, stakeRev] = this.findBet(odds, stake1, stake2);
                    let bet = betRev / odds;
                    let stake = parseFloat(stake1) + parseFloat(betRev);
        
                    return [bet, stake];
                case -1: //Back
                    return this.findBet(odds, stake1, stake2);
                default:
                    return [0, 0]
            }
        },
        findBet(odd1, s1, s2) {
            try {
                if (s1 == s2) return [0, s1];
        
                let a1 = s1 > 0 ? odd1 : 1 / odd1, c1 = -s1;
                let a2 = -1, c2 = -s2;
        
                a2 -= a1;
                c2 -= c1;
        
                let bet = c2 / a2;
                let newStake = (-a1 * bet + c1);
        
                return [bet, -newStake];
            } catch (e) {
                console.log('===', e)
            }
        },
        calculateCashoutStakeForBookmaker(bookData) {
            if (bookData.book) {
        
                let runners = bookData.book.sort((a, b) => a.pl - b.pl)
        
                let r1 = runners[0];
                let r2 = runners[1];
                r1.pl = parseFloat(r1.pl).toFixed(2)
                r2.pl = parseFloat(r2.pl).toFixed(2)
        
                let betType;
                let betStake;
                let cashoutStake;
                let betOdds;
        
                if (bookData.unavailableRunners == 1) {
                    if (r1.ss == 'SUSPEND') {
                        betType = 1; //lay
                        betOdds = r2.lay_odds
                    } else {
                        betType = -1; //back
                        betOdds = r1.back_odds
                    }
                } else if (!bookData.unavailableRunners) {
                    betType = -1; //back
                    betOdds = r1.back_odds
                } else {
                    return null
                }
        
                if (betType == 1) {
                    betStake = (r2.pl - r1.pl) / (betOdds);
                    cashoutStake = {
                        run1: parseFloat(r1.pl) + betStake,
                        run2: parseFloat(r2.pl) + (-1 * (((betOdds - 1) * 100) * betStake) / 100)
                    }
                } else if (betType == -1) {
                    betStake = (r2.pl - r1.pl) / (betOdds);
                    cashoutStake = {
                        run1: parseFloat(r1.pl) + (((betStake) * ((betOdds - 1) * 100)) / 100),
                        run2: parseFloat(r2.pl) - betStake
                    }
                }
                let real_bet_odds = (betOdds - 1) * 100;
                return ([{...r1, betOdds, betType, betStake, cashoutStake, real_bet_odds}]);
            }
        },
        calculateAlternateCashoutStake(book) {
            let runners = book.sort((a, b) => b.pl - a.pl)
        
            let r1 = runners[0];
            let r2 = runners[1];
        
            let betType = -1; //always back
            let betStake;
            let cashoutStake;
            let betOdds;
        
            betOdds = r2.back_odds
        
        
            betStake = (r1.pl - r2.pl) / (betOdds);
            cashoutStake = {
                run1: parseFloat(r1.pl) - betStake,
                run2: parseFloat(r2.pl) + (r2.back_odds * betStake) - betStake
            }
        
            let real_bet_odds = betOdds;
            return ([{...r2, betOdds, betType, betStake, cashoutStake, real_bet_odds}]);
        },
        getBook(market, type) {
            let runners = null;
            try {
                if (type == 'market') {
                    if (this.marketBookAndExposure && this.marketBookAndExposure.marketsBook && this.marketBookAndExposure.marketsBook.length) {
                        let marketBook = this.marketBookAndExposure.marketsBook.find(m => m.id == market.mid)?.runner_book;
                        marketBook = Object.create(marketBook);
                        if (!marketBook) {
                            return null
                        } else if (market.marketName == 'Who Will Win The Match?') {
        
                            for (let i = 0; i < marketBook.length; i++) {
        
                                for (let j = 0; j < market.runners.length; j++) {
                                    if (marketBook[i].selection_id == market.runners[j].sid) {
                                        marketBook[i] = {
                                            ...marketBook[i],
                                            back_odds: market.runners[j].ex.b?.[0]?.p,
                                            lay_odds: 0,
                                            sid: market.runners[j].sid,
                                            s: market.runners[j].s
                                        }
                                    }
                                }
                            }
                            return this.calculateAlternateCashoutStake(marketBook);
        
                        } else {
                            let cashoutUnavailableFlag = false;
                            for (let i = 0; i < marketBook.length; i++) {
        
                                for (let j = 0; j < market.runners.length; j++) {
                                    if (marketBook[i].selection_id == market.runners[j].sid) {
                                        marketBook[i] = {
                                            ...marketBook[i],
                                            back_odds: market.runners[j].ex.b?.[0]?.p,
                                            lay_odds: market.runners[j].ex.l?.[0]?.p,
                                            sid: market.runners[j].sid,
                                            s: market.runners[j].s
                                        }
                                        if (!cashoutUnavailableFlag && (!marketBook[i].back_odds || !marketBook[i].lay_odds || market.runners[j].s != 'ACTIVE')) {
                                            cashoutUnavailableFlag = true;
                                        }
                                    }
                                }
                            }
                            if (cashoutUnavailableFlag) {
                                return null
                            }
                            runners = marketBook
                        }
                    }
                } else if (type == 'bookmaker') {
                    if (this.marketBookAndExposure && this.marketBookAndExposure.bookmakersBook && this.marketBookAndExposure.bookmakersBook.length) {
                        let marketBook = this.marketBookAndExposure.bookmakersBook.find(m => m.id == market.mi)?.runner_book;
                        if (!marketBook || marketBook.length == 3) {
                            return null
                        } else if (market.mn == 'TOSS') {
        
                            for (let i = 0; i < marketBook.length; i++) {
        
                                for (let j = 0; j < market.sl.length; j++) {
                                    if (marketBook[i].selection_id == market.sl[j].si) {
                                        marketBook[i] = {
                                            ...marketBook[i],
                                            back_odds: market.sl[j].ss !== 'ACTIVE' || market.sn !== 'ONLINE' ? 0 : (market.sl[j].b / 100) + 1,
                                            lay_odds: market.sl[j].l,
                                            si: market.sl[j].si,
                                            ss: market.sl[j].ss
                                        }
                                    }
                                }
                            }
                            let data = {
                                book: marketBook,
                                unavailableRunners: 0
                            }
                            return this.calculateCashoutStakeForBookmaker(data);
        
                        } else {
        
                            let checkAllRunnerUnavailbableCount = 0;
                            for (let i = 0; i < marketBook.length; i++) {
        
                                for (let j = 0; j < market.sl.length; j++) {
                                    if (marketBook[i].selection_id == market.sl[j].si) {
                                        if (market.sl[j].ss !== 'ACTIVE' || market.sn !== 'ONLINE') {
                                            checkAllRunnerUnavailbableCount += 1
                                        }
                                        marketBook[i] = {
                                            ...marketBook[i],
                                            back_odds: market.sl[j].ss !== 'ACTIVE' || market.sn !== 'ONLINE' ? 0 : (market.sl[j].b / 100) + 1,
                                            lay_odds: market.sl[j].ss !== 'ACTIVE' || market.sn !== 'ONLINE' ? 0 : (market.sl[j].l / 100) + 1,
                                            si: market.sl[j].si,
                                            ss: market.sl[j].ss
                                        }
                                    }
                                }
                            }
                            let data = {
                                book: marketBook,
                                unavailableRunners: checkAllRunnerUnavailbableCount
                            }
                            return this.calculateCashoutStakeForBookmaker(data);
                        }
                    }
                }
        
            } catch (e) {
                console.log('=====', e)
            }
            let calculateBet = this.calculateCashoutStake(runners);
            return calculateBet;
        },
        getCashoutValue(market, type) {
            let betData = this.getBook(market, type);
            return {
                value: this.chashOutRunnerBook(betData, type, market),
                betData: betData
            };
        },
        chashOutRunnerBook(betData, type, market) {
            if (betData && betData.length) {
                let finalBetStake = type == 'market' && market.marketName != 'Who Will Win The Match?' ? betData[0]?.finalStake : betData[0].cashoutStake?.run1 ? betData[0].cashoutStake?.run1 : betData[0]?.finalStake;
                if (finalBetStake >= 0) {
                    return '<span class="cashout back-win">' + parseFloat(finalBetStake).toFixed(2) + '</span>';
                } else {
                    return '<span class="cashout lay-loss">' + ((-1) * parseFloat(finalBetStake).toFixed(2)) + '</span>';
                }
            }
        },
        cashoutServiceCall(market, type) {
            this.cashoutDetails.market = market;
            this.cashoutDetails.betOdd = this.cashoutMarketData?.[type == 'bookmaker' ? market.mi : market.mid]?.bet?.real_bet_odds;
            this.cashoutDetails.type = type;
            this.cashoutSlipCloseTime = setTimeout(() => {
                if(!this.CashoutLoader) {
                    this.$helper.closeModal('cashoutModal');
                }
            }, 10000)
        },
        closeCashout() {
            this.cashoutDetails = {}; 
            clearTimeout(this.cashoutSlipCloseTime)
        },
        callforCashout() {
            let market = this.cashoutDetails.market;
            let type = this.cashoutDetails.type;
            let data = {
                match_id: this.eventDetails.matchId,
                bet_type: type,
                market_id: type == 'bookmaker' ? market.mi : market.mid,
                event_id: this.eventDetails.eventId,
                sport_id: this.eventDetails.sportId,
                validate: 0,
                betId : this.$dateTime.currentTimestamp(),
                userid: this.$auth.user.userid,
                bet_delay: type == 'bookmaker' ? 	(market.bd || 0) : (market.bet_delay || 0),
                odds: this.cashoutDetails?.betOdd
            }
            this.CashoutLoader = true;
            this.$apiCall('post','BET_CASHOUT', data).then(response => {
                if (response.status == 200) {
                    try {
                        this.getEventExposures();
                        this.CashoutLoader = false;
                        this.$helper.closeModal('cashout-modal')
                        this.$successToast(response.data.message)
                    } catch (e) {
                        console.log(e);
                    }
                }
            }).catch(error => {
                this.CashoutLoader = false;
                this.$helper.closeModal('cashout-modal');
                this.$errorToast(error[0])
            })
        },
    }
}
